import axios from "axios";
import InfoSections from "@/mockData/InfoSections.json";
import InfoArticles from "@/mockData/InfoArticles.json";

export default class GeneralInfoServices {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getSections() {
    try {
      const sections = InfoSections.data;
      return sections;
    } catch (error) {
      throw error;
    }
  }

  async getArticles() {
    try {
      const sectionsData = await this.getSections();
      const articles = await axios({
        method: "get",
        url: `${this.API_LINK}/plant/post`
      });
      const sections = sectionsData.map(section => {
        const sectionPosts = articles.data.posts.filter(article => {
          // let match = true;
          // const indexes = ["category", "previewType", "renderType", "type"];
          // // for(let index in article) {
          // indexes.forEach(index => {
          //   if(article.)
          //   if(section.options[index]){
          //     if(section.options[index] != article[index]) {
          //       match = false;
          //     }
          //   } else {
          //     match = false;
          //   }
          // });
          return (section.options.category == article.category &&
                  section.options.previewType == article.previewType &&
                  section.options.renderType == article.renderType &&
                  section.options.type == article.type);
          return match;
        });
        section.articles = sectionPosts.length ? sectionPosts.reverse() : null;
        return section;
      });
      return sections;
    } catch (error) {
      // console.log(error);
      throw error;
    }
  }

  async getArticle(id) {
    try {
      const url = `${this.API_LINK}/plant/post/${id}/`;
      const response = await axios({
        method: "get",
        url: url
      });
      const article = response.data;
      article.section = this._getSectionId(article.category, article.previewType, article.renderType).id;
      return article;
    } catch (error) {
      throw error.response;
    }
  }

  _getSectionId(category, previewType, renderType) {
    const sectionsData = InfoSections.data;
    const sectionId = sectionsData.filter(section => (
      section.options.category == category &&
      section.options.previewType == previewType &&
      section.options.renderType == renderType
    ))[0];
    return sectionId;
  }

  async postArticle(newArticle) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/plant/post`,
        data: newArticle
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async updateArticle(article, id) {
    try {
      const response = await axios({
        method: "patch",
        url: `${this.API_LINK}/plant/post/${id}/`,
        data: article
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async deleteArticle(id) {
    try {
      const response = await axios({
        method: "delete",
        url: `${this.API_LINK}/plant/post/${id}/`
      });
      return response.data;
    } catch (error) {
      throw error.response;
    }
  }
}